module.exports = __webpack_public_path__ + "static/media/login_al_bg.5df426e8.png";